<template>
  <div class="form">
    <a id="form" href="#" class="anchor"></a>
    <div class="flex <laptop:flex-col">
      <div class="flex-1">
        <FormItem
          class="form-item-block"
          label="你的姓名*"
          placeholder="美業歐膩"
          :error="v$.name.$error"
          errorMsg="此為必填欄位"
          v-model:value="formData.name"
        />
        <FormItem
          class="form-item-block"
          label="聯絡電話*"
          placeholder="0900000000"
          :error="v$.phone.$error"
          errorMsg="此為必填欄位"
          v-model:value="formData.phone"
        />
        <FormItem
          class="form-item-block"
          label="店家名稱*"
          placeholder="歐膩的店"
          :error="v$.shopName.$error"
          errorMsg="此為必填欄位"
          v-model:value="formData.shopName"
        />
        <FormItem
          class="form-item-block"
          label="店家產業*"
          placeholder="美甲/美睫/美髮/紋繡/美容做臉/按摩SPA/其他..."
          :error="v$.shopType.$error"
          errorMsg="此為必填欄位"
          v-model:value="formData.shopType"
        />
        <FormItem
          class="form-item-block"
          label="店家地址*"
          placeholder="台北市松山區美業路"
          :error="v$.shopAddress.$error"
          errorMsg="此為必填欄位"
          v-model:value="formData.shopAddress"
        />
      </div>
      <div class="w-[30px]"></div>
      <div class="flex-1 flex flex-col">
        <FormItem
          class="form-item-block flex-1"
          label="想了解的內容（選填）"
          placeholder="請輸入您想詢問的問題，或是想跟歐巴說的話～"
          type="textarea"
          v-model:value="formData.question"
        />
        <div class="laptop:h-[72px]"></div>
        <button v-if="!sending" class="submit-form-btn" @click.prevent="sendForm">
          送出
        </button>
        <button v-if="sending" disabled class="submit-form-btn">寄送中</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from '@vue/reactivity'
import FormItem from './components/FormItem.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { gtmEvents } from '@/config/config-gtm-events'
import configuration from '@/configuration'
import axios from 'axios'

const sending = ref(false)
const formData = reactive({
  name: '',
  phone: '',
  shopName: '',
  shopType: '',
  shopAddress: '',
  question: '',
})

const formRules = {
  name: { required },
  phone: { required },
  shopName: { required },
  shopType: { required },
  shopAddress: { required },
  question: {},
}

const v$ = useVuelidate(formRules, formData, { $autoDirty: true })
const resetForm = () => {
  formData.name = ''
  formData.phone = ''
  formData.shopName = ''
  formData.shopType = ''
  formData.shopAddress = ''
  formData.question = ''
}
const sendForm = async () => {
  const valid = await v$.value.$validate()
  if (!valid) {
    alert('表單欄位輸入有誤！')
    return
  }
  sending.value = true
  const api = `${configuration('formHost')}/beautinqForm`
  const userForm = {
    formData: {
      name: formData.name,
      phone: formData.phone,
      enterprise: formData.shopName,
      category: formData.shopType,
      address: formData.shopAddress,
      content: formData.question,
    },
  }

  try {
    await axios({
      url: api,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: userForm,
    })

    alert('您已成功送出表單！')
    window.dataLayer.push({
      event: gtmEvents.SEND_FORM_SUCCESS,
    })
    resetForm()
    window.location.reload(true)
    sending.value = false
  } catch (error) {
    console.log(error)
    alert('歐嗚！發生錯誤，請先使用右下方黃色訊息溝通')
    sending.value = false
  }
}
</script>

<style scoped lang="postcss">
.form {
  @apply max-w-[1037px] m-auto px-[24px] pb-[81px];
  @apply <tablet: (pb-[31.98px]);
}

.form-item-block {
  @apply mt-[18px] text-[35px];
  @apply <tablet: (mt-[10px] text-[16px]);
}

.submit-form-btn {
  @apply w-full py-[10px] text-[23.33px] rounded-[7px] bg-primary-100 text-white;
  @apply <tablet: (text-[16px] rounded-[8px] mt-[16px] py-[9px] leading-[23.17px]);
}

</style>
